export default "__VITE_ASSET__DOeccWyT__"